import { httpV1 as http } from '../api';

export async function getBanks(params) {
  return http.get('/payments/banks', { params });
}

export async function getBanksForPromoters() {
  return http.get('/payments/banks-commission');
}

export async function getCreditors(params) {
  return http.get('/creditors', { params });
}
